<template>
  <div>
    <div v-for="(item, index) in inputValues" :key="index" class="input-row">
      <div class="input-item">
        <el-select
          v-model="item.coin"
          placeholder="请选择"
          @change="handleChange(index)"
        >
          <el-option
            v-for="coin in coinTypeList"
            :key="coin"
            :label="coin"
            :value="coin"
          ></el-option>
        </el-select>
        <el-input-number
          placeholder="价格"
          :min="0"
          v-model="item.price"
          @input="handleChange"
          :disabled="disabled"
        ></el-input-number>
        <el-input-number
          placeholder="系数"
          :min="0"
          v-model="item.cof"
          @input="handleChange"
          :disabled="disabled"
        ></el-input-number>
      </div>
      <el-button
        type="primary"
        icon="el-icon-minus"
        circle
        @click="removeInput(index)"
      ></el-button>
      <div v-if="item.coin === 'USDT'" class="recommand">
        推荐价格: {{ getRecommandPrice(item.coin) }}
      </div>
    </div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      circle
      @click="addInput"
    ></el-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'mutipleInput',
  props: ['value', 'disabled'],
  data() {
    return {
      inputValues: this.value && this.value.length ? this.value.concat() : [],
      newPair: ''
    };
  },
  computed: {
    ...mapState('purchaseProject', ['coinTypeList', 'relativePrice'])
  },
  watch: {
    value: {
      handler(val) {
        this.inputValues = val && val.length ? val.concat() : [];
      },
      deep: true
    }
  },
  methods: {
    getRecommandPrice(coin) {
      const usdtItem = this.inputValues.find(item => item.coin === 'USDT');
      if (usdtItem) {
        const price = usdtItem.price;
        const relativePriceItem = this.relativePrice.find(
          item => item.pair === coin + '_USDT'
        );
        if (relativePriceItem) return relativePriceItem.currentPrice * price;
      }
      return '';
    },
    handleChange() {
      this.$emit('change', this.inputValues);
      this.$emit('input', this.inputValues);
      this.$parent.$emit('el.form.change', this.inputValues);
    },
    addInput() {
      this.inputValues.push({ coin: '', price: '', cof: '' });
    },
    removeInput(index) {
      this.inputValues.splice(index, 1);
    }
  }
};
</script>

<style lang="less">
.input-row {
  margin-bottom: 10px;
  display: flex;
}
.input-item {
  display: flex;
  & > * {
    margin: 0 5px;
  }
}
.recommand {
  margin-left: 10px;
  font-size: 13px;
}
</style>
